import React from "react";
import "./Global_Big_Data.css";

const Global_Big_Data = () => {
  return (
    <section className="Global_Big_Data">
      <div className="container">
        <div className="Global_Big_Data_header_div">
          <div className="Global_Big_Data_header">
            <h5 className="title">
              {" "}
              Global Big Data & <span>
                {" "}
                Data Engineering Service Market
              </span>{" "}
            </h5>
            <h6 className="subtititle">Market Overview</h6>
          </div>
        </div>

        <div className="Global_Big_Data_content">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-3 col-md-4 col-sm-4 col-7 mb-4">
              <div className="left_content">
                <h5 className="left_number">17.6</h5>
                <div className="global_div">
                  <p className="global">Global Market CAGR</p>
                  <p className="global">2023 - 2034</p>
                </div>
              </div>
            </div>

            <div className="col-lg-8 col-md-8 col-sm-8 col-12">
              <div className="right_col">
                <img
                  src="/assets/images/pst_it_solution/Global_Big_Data/assets.png"
                  alt="assets"
                  className="assets_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Global_Big_Data;
